import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
 
const AlertTextInputModal = ({ show, onHide, currentMessages, onSave }) => {
  const [inputText, setInputText] = useState("");
 
  useEffect(() => {
    if (show && Array.isArray(currentMessages)) {
      const messagesString = currentMessages.map(item => item.Message).join('\n');
      setInputText(messagesString);
    }
  }, [show, currentMessages]);
 
  const handleSave = () => {
    const newMessages = inputText.split('\n')
      .map(msg => msg.trim())
      .filter(msg => msg.length > 0)
      .map((msg, index) => ({ id: index, Message: msg }));
 
    onSave(newMessages);
    onHide();
  };
 
  return (
<Modal show={show} onHide={onHide} centered>
<Modal.Header closeButton>
<Modal.Title>Edit Scrolling Alert Text</Modal.Title>
</Modal.Header>
<Modal.Body>
<Form.Group controlId="alertMessageTextarea" className="mb-4"> 
<Form.Label className="font-semibold text-gray-700"> 
            Enter one alert message per line:
</Form.Label>
<Form.Control
            as="textarea"
            rows={5}
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="Type your alert message here..."
          />
</Form.Group>
</Modal.Body>
<Modal.Footer>
<Button variant="secondary" onClick={onHide}>
          Close
</Button>
<Button 
          variant="primary" 
          onClick={handleSave} 
          className="bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500" 
>
          Save Changes
</Button>
</Modal.Footer>
</Modal>
  );
};
 
export default AlertTextInputModal;